"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.T = exports.withT = exports.useT = exports.context = exports.Trans = exports.Provider = exports.Consumer = void 0;
var tslib_1 = require("tslib");
var createTranslations_1 = require("./createTranslations");
tslib_1.__exportStar(require("./types"), exports);
exports.Consumer = (_a = createTranslations_1.default(), _a.Consumer), exports.Provider = _a.Provider, exports.Trans = _a.Trans, exports.context = _a.context, exports.useT = _a.useT, exports.withT = _a.withT, exports.T = _a.T;
